import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class TranslateApiService {
  private api = inject(VwApiRequestsService);

  toMarathi(text: string) {
    return this.api.postAPICall('/translate', { text });
  }
}
